import { render } from "./FiltersSection.vue?vue&type=template&id=6491cced"
import script from "./FiltersSection.vue?vue&type=script&lang=js"
export * from "./FiltersSection.vue?vue&type=script&lang=js"
script.render = render

export default script